import {Injectable, signal} from '@angular/core';
import {NoteFilesData} from "../types/note-files-modal.types";

@Injectable({
  providedIn: 'root'
})
export class NoteFilesStateService {
  private _noteFilesState = signal<Array<NoteFilesData>>([]);
  public noteFilesState = this._noteFilesState.asReadonly();

  public setInitialNoteFilesState(files: Array<NoteFilesData>): void {
    this._noteFilesState.set(files);
  }

  public updateNoteFilesState(value: NoteFilesData): void {
    this._noteFilesState.update(current => {
      const newValue = current ? [ ...current ] : [];

      return [ ...newValue, value ];
    });
  }

  public deleteNoteFilesState(id: number): void {
    this._noteFilesState.update(current => {
      if (!current.length) { return []; }

      const newValue = [...current ].filter(i => i.file.id !== id);

      return !Object.keys(newValue).length ? [] : newValue;
    });
  }

  public getNoteFilesStateId(fileId: number): number {
    return this.noteFilesState()?.find(file => file.file.id === fileId)?.id || 0;
  }

  public resetNoteFilesState(): void {
    this._noteFilesState.set([]);
  }
}
